import React, { ReactNode } from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box, Flex } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

type ContentMenuProps = {
	children?: ReactNode;
	label?: ReactNode;
};

const styles = cssMap({
	heading: {
		paddingBlock: token('space.100'),
		paddingLeft: token('space.075'),
		paddingTop: token('space.100'),
		paddingBottom: token('space.100'),
		color: token('color.text.subtle'),
		font: token('font.body'),
		fontWeight: token('font.weight.semibold'),
		display: 'flex',
		alignItems: 'center',
	},
});

// MenuSection is responsible for seperating logical groups of menu items.
// it is primarily used to seperate the promoted site from the rest of the menu items.
export const MenuSection = ({ children, label }: ContentMenuProps) => {
	return (
		<Flex direction="column">
			{label && <Box xcss={cx(styles.heading)}>{label}</Box>}
			{children}
		</Flex>
	);
};
